<template>
  <h2>403 Forbidden</h2>
</template>
<script>
export default {
  name: 'Err403View'
}
</script>
